module.exports = __webpack_public_path__ + "assets/fa800b4c6b2da10c6f1a6249da8ad7a9.png";